import { Path } from "react-native-svg";
import { createIcon } from "../Icon";

export const ProfileIcon = createIcon({
	viewBox: "0 0 24 24",
	path: (
		<>
			<Path
				d="M11.8394 0.99998C8.7712 0.99998 6.28389 3.41075 6.28389 6.38459C6.28389 8.51593 7.56151 10.3581 9.41494 11.2307C9.66755 11.7692 9.98304 13.5214 9.09415 14.3829C4.18221 15.1007 1 17.0381 1 19.8172C1 21.4164 2.7529 22.6183 11.7984 22.6183C21.2428 22.6183 22.6865 21.4163 22.6633 19.8172C22.6233 17.0755 19.6965 15.1823 14.6372 14.3829C13.7339 13.4122 14.0341 11.6694 14.2737 11.2435C16.3633 10.1788 17.395 8.37766 17.395 6.38459C17.395 3.41075 14.9077 0.99998 11.8394 0.99998Z"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
		</>
	),
});
